import { normalizeAirHandlerTypeCode } from '@alpinehomeair/common';
import { AirHandlerTypeCodeType, CondenserType } from 'data/types';
import { getEffectivePerZoneTypes } from 'utils/air-handler-availability';

export function isAirHandlerTypeAllowedInZone(
  airHandlerTypeCode: AirHandlerTypeCodeType,
  condenser: Pick<CondenserType, 'airHandlerOptions' | 'zones'>,
  zoneUniqueId: string
): boolean {
  const perZoneTypes = getEffectivePerZoneTypes(condenser);
  if (!perZoneTypes) return true;

  const allowed = perZoneTypes[zoneUniqueId];
  if (!allowed) return false;

  const normalized = normalizeAirHandlerTypeCode(airHandlerTypeCode);
  return allowed.includes(normalized);
}
